import { bridge } from '~/services/bridge'

/**
 * Resolve an API URL. In plugin mode, prepends the API base URL
 * since the webview origin differs from the API server.
 * In browser mode, returns the URL as-is (relative URLs work with cookies).
 */
export function resolveApiUrl(url: string): string {
  if (bridge.isInPlugin() && url.startsWith('/')) {
    return `${bridge.getBaseUrl()}${url}`
  }
  return url
}
